import {
  authReq
} from '@/utils/http'

const getMerchants = (page, pageSize = 10, sort = '', condition = {}) => {
  return authReq.get('/api/v1/bank/merchant_info', {
    'page_size': pageSize,
    page,
    sort,
    ...condition
  })
}

const updateMerchantInfo = (merchantId, corpName, name, address, acctName, acctNo, certNo, certStartAt, certExpireAt) => {
  return authReq.put(`/api/v1/bank/merchant_info/${merchantId}`, {
    'corp_name': corpName, // 法人姓名
    'acct_name': acctName, // 开户人
    'acct_no': acctNo, // 开户银行卡号
    'busilic_no': certNo, // 身份证号
    'acct_cert_no': certNo, // 身份证号
    'corp_cert_no': certNo, // 身份证号
    'cert_start_date': certStartAt, // 身份证办理时间
    'cert_expire_date': certExpireAt, // 身份证过期时间
    name, // 商户姓名
    address // 商户地址
  })
}

const updateMerchantPayInfo = (merchantId, nowPayChannel, jdReview, sbReview) => {
  return authReq.put(`/api/v1/bank/merchant_info/${merchantId}/pay`, {
    'now_pay_channel': nowPayChannel,
    'jd_review': jdReview,
    'sb_review': sbReview
  })
}

const updateMerchantInfoWithImg = (data) => {
  return authReq.put(`/api/v1/bank/merchant_info/${data.merchantId}`, {
    'corp_name': data.corpName, // 法人姓名
    'acct_name': data.acctName, // 开户人
    'acct_no': data.acctNo, // 开户银行卡号
    'busilic_no': data.certNo, // 身份证号
    'acct_cert_no': data.certNo, // 身份证号
    'corp_cert_no': data.certNo, // 身份证号
    'cert_start_date': data.certStartAt, // 身份证办理时间
    'cert_expire_date': data.certExpireAt, // 身份证过期时间
    'hold_id_card': data.holdIdcard,
    'id_card_z': data.idcardZ,
    'id_card_f': data.idcardF,
    'bank_z': data.bankZ,
    'bank_f': data.bankF,
    'sb_email': data.sbEmail,
    email: data.email,
    hetong: data.hetong,
    mendian: data.mendian,
    shinei: data.shinei,
    shouyintai: data.shouyintai,
    name: data.name, // 商户姓名
    address: data.address, // 商户地址
    prov: data.prov,
    city: data.city,
    area: data.area
  })
}

const completeMerchantInfo = (merchantId, hetong, mendian, shinei, shouyintai) => {
  return authReq.post('/api/v1/bank/merchant_info/supply', {
    'merchant_id': merchantId, hetong, mendian, shinei, shouyintai
  }, 20 * 1000)
}

const reReviewMerchantInfo = (merchantId, jd, sb) => {
  return authReq.post('/api/v1/bank/merchant_info/re_review', {
    'merchant_id': merchantId, jd, sb
  }, 20 * 1000)
}

const getIdcardImg = (merchantId) => {
  return authReq.get(`/api/v1/bank/merchant_info/${merchantId}/id_card`)
}

const getSplitAccounts = (page, pageSize = 10, sort = '', condition = {}) => {
  return authReq.get('/api/v1/bank/split_account', {
    'page_size': pageSize,
    page,
    sort,
    ...condition
  })
}

const passSplitAccount = (splitAccountId, status, applyRule) => {
  return authReq.post('/api/v1/bank/split_account/pass', {
    'split_account_id': splitAccountId,
    'apply_rule': applyRule,
    status
  })
}

const downloadBill = (merchantId, date) => {
  return authReq.get(`/api/v1/bank/merchant_info/${merchantId}/bill`, { date })
}

const queryWxNo = (merchantId) => {
  return authReq.get(`/api/v1/bank/merchant_info/${merchantId}/wx_no`)
}

const copyJdChannelInfo = (merchantId, srcMerchantId) => {
  return authReq.put(`/api/v1/bank/merchant_info/${merchantId}/jd/copy`, {
    'src_merchant_id': srcMerchantId
  })
}

export default {
  getMerchants,
  updateMerchantInfo,
  updateMerchantPayInfo,
  updateMerchantInfoWithImg,
  completeMerchantInfo,
  reReviewMerchantInfo,
  getIdcardImg,
  downloadBill,
  queryWxNo,
  copyJdChannelInfo,

  getSplitAccounts,
  passSplitAccount
}



// WEBPACK FOOTER //
// ./src/api/bankApi.js